// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticleShareButtons-cls1__Rw","cls2":"ArticleShareButtons-cls2_IG5 ArticleShareButtons-cls1__Rw"};